<template>
  <div class="main">
    <my_menu2 v-if="menu_show" :page_name="job_status == 0
      ? company_short_name + ' - 长期工在职花名册'
      : company_short_name + ' - 长期工离职花名册'
      " back_type="close" back_icon="md-close"></my_menu2>
    <div style="height: 40px"></div>
    <!-- <div class="page_title">
      <div :title="roster_template_info.name">
        <span class="back_home" @click="bank_home">
          <Icon type="md-arrow-back" />返回首页&nbsp;|&nbsp;
        </span>
        <span>
          {{ company_short_name }}项目-{{ job_status == 0 ? "在职" : "离职" }}-员工花名册
        </span>
      </div>

      <div>
        <span class="cut_roster" @click="cut_roster_status">
          <Icon type="md-swap" />在职、离职花名册切换
        </span>
        <span class="button_span">|</span>
        <span class="export_hmc2" @click="click_project_contract_list">
          <Icon type="md-bookmarks" />合同列表
        </span>
        <span class="button_span">|</span>

        <span class="export_hmc" @click="export_hmc">
          <Icon type="md-download" />导出{{ job_status == 0 ? "在职" : "离职" }}花名册
        </span>

      </div>
    </div> -->
    <!-- <div class="options_box">
                        <div class="editor_div">
                            <span>编辑：</span>
                            <Switch size="small" />
                        </div>
                    </div> -->

    <div class="search_div">
      <div class="search_div_left">
        <Select v-model="search_type" size="small" style="width:100px">
          <Option v-for="item in search_type_list" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>

        <Input v-if="search_type == 'name'" v-model="search_value" @on-search="search" @on-enter="search"
          style="width: 130px" size="small" search enter-button placeholder="按姓名搜索" />

        <div v-if="search_type == 'idcard_list'" class="search_idcard_list_div">
          <div class="search_idcard_list_btn" @click="search_idcard_list_show = true">
            {{ search_idcard_list.length > 0 ? `${search_idcard_list.length}条` : '点击填写身份证号列表' }}
          </div>
          <div class="search_idcard_list_btn" @click="search">
            <Icon type="ios-search-outline" />搜索
          </div>
        </div>
        <!-- <span class="search_d  iv_span">点击姓名查看简历详情</span> -->
      </div>

      <div>
        <Button size="small" type="success" style="font-size: 12px; margin-right: 5px" @click="click_add_bed">
          <span class="iconbed iconfont " style="font-size:12px"></span>&nbsp;分配宿舍
        </Button>
        <Button size="small" style="font-size: 12px; margin-right: 5px" @click="click_project_contract_list">
          <Icon type="md-bookmarks" />&nbsp;合同列表
        </Button>
        <Button size="small" style="font-size: 12px; margin-right: 5px" @click="batch_update_show = true">
          <Icon type="ios-add-circle-outline" />&nbsp;批量更新信息
        </Button>
        <Button size="small" style="font-size: 12px; margin-right: 5px" @click="click_import_hmc">
          <Icon type="ios-add-circle-outline" />&nbsp;导入花名册
        </Button>
        <Button size="small" style="font-size: 12px; margin-right: 5px" @click="export_hmc_before">
          <Icon type="md-download" />&nbsp;导出花名册
        </Button>
        <Button size="small" style="font-size: 12px; margin-right: 5px" @click="click_transfer_project">
          <Icon type="ios-redo" />&nbsp;转移项目
        </Button>
        <Button size="small" style="font-size: 12px; margin-right: 5px" @click="click_transfer_project_duanqi">
          <Icon type="ios-redo" />&nbsp;转移至短期工
        </Button>
        <Button type="primary" size="small" style="font-size: 12px; margin-right: 5px" @click="batch_insured">
          <Icon type="ios-add-circle-outline" />&nbsp;参保险
        </Button>
        <Button type="warning" size="small" style="font-size: 12px" @click="gongshang_baoan">
          <Icon type="ios-add-circle-outline" />&nbsp;工伤报案
        </Button>
      </div>
    </div>

    <div class="table_box">
      <Spin fix v-show="table_loading"></Spin>

      <Table size="small" :columns="columns" :data="table_data" :height="windowHeight - 140"
        @on-selection-change="selection_change">
        <template #name="{ row }">
          <span class="roster_name" @click="click_name(row)">{{ row.name }}</span>
        </template>
        <template #idcard="{ row }">
          <div class="idcard_span_div">
            <span @click="click_idcard_num(row)" title="点击更新身份证" class="idcard_num">{{ row.idcard }}</span>
            <i title="已实名" v-if="row.is_certification == 1" class="iconfont iconrenzheng"></i>
            <i title="未实名" v-else class="iconfont iconweirenzheng" @click="click_update_certification(row)"></i>

            <i v-if="row.idcard_img_status == 1" class="iconfont iconsfz1 sfz_icon1" title="身份证照片已完善"></i>
            <i v-if="row.idcard_img_status == 0" class="iconfont iconsfz1 sfz_icon2" title="身份证照片没有完善"></i>
          </div>
        </template>
        <template #field_id_ed7ce15fa2="{ row }">
          <span v-if="row.field_id_ed7ce15fa2 == ''" style="color:red;font-weight: 600;">未关注</span>
          <span v-else>已关注</span>
        </template>
        <template #bank_card="{ row }">
          <span @click="click_resume_bank_card(row)" class="bank_card1 bank_card_hover"
            v-if="row.resume_bank_default_status == 1">已完善({{ row.resume_bank_card_count }})</span>
          <span @click="click_resume_bank_card(row)" class="bank_card2 bank_card_hover" v-else>未完善</span>
        </template>
        <template #geshui="{ row }">
          <span @click="view_geshui(row)" class="bank_card1 bank_card_hover" v-if="row.geshui_img != ''">已完善</span>
          <span @click="upload_geshui(row)" class="bank_card2 bank_card_hover" v-else>未完善</span>
        </template>
        <template #action="{ row }">
          <div class="action2">
            <span @click="click_editor(row)" class="editor_table">编辑</span>
            <div @click="click_contract(row)" style="margin: 0 7px" class="editor_table2">
              合同({{ contract_dict[row.idcard] }}/{{ total_contract_dict[row.idcard] }})
              <!-- <div class="contract_point"></div> -->
            </div>
            <span @click="click_insurance(row)" class="editor_table">保险({{ insurance_count_dict[row.idcard] }})</span>
          </div>
        </template>
      </Table>
    </div>
    <div class="page_div">
      <Page show-total show-elevator :total="total_count" v-model="page" @on-change="page_change" :page-size="limit" />
    </div>

    <Modal width="430" v-model="contract_modal_show" title="选择要进行的操作" @on-ok="contract_ok">
      <div class="contract_button_div">
        <Button class="contract_button_class" @click="click_sing_contract(0)">
          <i class="iconfont icongaizhang"></i>
          单个签合同</Button>
        <Button class="contract_button_class" @click="click_sing_contract(1)">
          <i class="iconfont iconqianshu"></i>
          批量签合同</Button>
        <Button class="contract_button_class" @click="click_sing_contract(2)">
          <i class="iconfont iconqianshu"></i>
          上传纸质合同</Button>
      </div>
      <div style="margin-top: 20px">
        <Button class="contract_button_class3" type="primary" @click="click_contract_list()">
          <i class="iconfont iconhetongleibiao"></i>
          合同签署详情</Button>
      </div>
    </Modal>

    <Modal v-model="faxin_show" title="发薪重要通知" :mask-closable="false" :footer-hide="true" width="500">
      <div>
        请检查及时完善员工<span style="color:red">收款工资卡</span> ，可由驻厂自行完善，或引导员工到微信公众号【大湘员工服务中心】自行设置默认收款银行卡，收款工资卡未完善可能导致发薪失败或异常！
      </div>

    </Modal>


    <Modal v-model="roster_template_show" title="选择模板" :footer-hide="true">
      <div class="roster_detail">
        <p>检测您第一次使用花名册，需要选择花名册的模板，请选择后点击确认。</p>
      </div>
      <div class="roster_item">
        <span>花名册模板：</span>
        <Select v-model="roster_select" style="width: 300px" placeholder="请选择模板">
          <Option v-for="item in roster_template_list" :value="item.value" :key="item.value">{{ item.label }}
          </Option>
        </Select>
      </div>
      <div class="roster_template_button">
        <Button style="font-size: 12px" type="primary" @click="update_roster">
          <Icon type="md-checkmark" /> 确认使用该模板
        </Button>
      </div>
    </Modal>

    <Modal width="300" v-model="insurance_show" title="选择要进行的操作">
      <div>
        <!-- <Button class="contract_button_class" @click="click_insurance_audit">
                                <i class="iconfont icongaizhang"></i>
                                提交参保异动</Button> -->
        <Button class="contract_button_class" @click="click_insurance_list()">
          <i class="iconfont iconhetongleibiao"></i>
          查看参保详情</Button>
      </div>
    </Modal>

    <Modal v-model="transfer_project_show" title="转移项目" :footer-hide="true" width="500">
      <div class="transfer_tishi">
        提示：本功能是将员工转移至其他项目，可按转移类型进行多种转移模式。
      </div>
      <div class="transfer_toproject_box">
        <div style="margin: 10px 0">
          <span class="transfer_title">目标项目：</span>
        </div>
        <Select v-model="to_project_id" filterable size="small">
          <Option v-for="item in project_options" :value="item.value" :key="item.value">{{
            item.label
          }}</Option>
        </Select>
      </div>


      <div class="transfer_toproject_box">
        <div style="margin: 10px 0">
          <span class="transfer_title">转移类型</span>
        </div>
        <div class="transfer_tishi2">
          说明：<span style="color:red">无痕转移：</span>会将入职数据转为新项目，不保留旧项目数据，旧的入职记录信息会消失；共
          1条入职记录<br><span style="color:red">离职转移：</span>转移后人员将在本项目离职，在目标项目入职，保留入职记录，共2条入职记录<br><span
            style="color:red">（1）保留旧入职时间:</span>将从本项目离职，新项目入职，但入职时间为旧项目的入职时间；<br><span
            style="color:red">（2）生成新入职时间</span>，则从这个项目离职，新项目入职，入职时间为当前操作时间
        </div>

        <div style="height:10px"></div>
        <Select v-model="transfer_type" filterable size="small">
          <Option value="01">无痕转移</Option>
          <Option value="02">离职转移</Option>
        </Select>
      </div>

      <div class="transfer_toproject_box">
        <div style="margin: 10px 0">
          <span class="transfer_title">转移合同状态</span>
        </div>
        <Select v-model="transfer_contract_status" size="small">
          <Option :value="0">否</Option>
          <Option :value="1">是</Option>
        </Select>
      </div>

      <div class="transfer_toproject_box">
        <div style="margin: 10px 0">
          <span class="transfer_title">转移保险状态</span>
        </div>
        <Select v-model="transfer_insurance_status" size="small">
          <Option :value="0">否</Option>
          <Option :value="1">是</Option>
        </Select>
      </div>

      <div class="transfer_toproject_box" v-if="transfer_type == '02'">
        <div style="margin: 10px 0">
          <span class="transfer_title">转移后入职相关日期选择</span>
        </div>
        <Select v-model="transfer_time_type" filterable size="small">
          <Option value="old">保留旧入职时间</Option>
          <Option value="new">生成新的入职时间</Option>
        </Select>
      </div>
      <div class="transfer_button">
        <Button class="transfer_button" @click="click_transfer_project_affirm()" type="primary">
          确认转移</Button>
      </div>
    </Modal>

    <Modal v-model="transfer_project_duanqi_show" title="转移长期工人员到短期工" :footer-hide="true" width="500">
      <div class="transfer_tishi">
        提示：正在转移人员至短期工，转移后人员将在短期工花名册，不支持转回，是否开始转移？
      </div>

      <div class="transfer_button">
        <Button class="transfer_button" style="margin-top:10px" @click="click_transfer_project_duanqi_affirm()"
          type="primary">
          确认转移({{ selection_data.length }}人)</Button>
      </div>
    </Modal>

    <Modal width="400" v-model="batch_update_show" title="批量更新信息" :footer-hide="true">
      <div>
        <div>
          操作注意事项：<br />
          请先下载模板，完善后将文件上传进行导入，一定要用模板文件！<br />
          每个项目花名册对应一个模板，随意上传文件会导致更新数据错乱！<br />
          注意长数字的单元格格式，如银行卡号等，单元格格式要设置为文本，否则更新后可能会精度失真，尾数为00
        </div>
        <div class="update_batch_div">
          <Button class="contract_button_class" @click="batch_update_template()">
            <Icon type="ios-cloud-download-outline" />
            下载模板
          </Button>
        </div>
        <div class="update_batch_div">
          <Upload ref="update_batch_upload" :action="batch_update_file_update" :on-success="update_file_upload_success">
            <Button icon="ios-cloud-upload-outline" type="primary">上传文件</Button>
          </Upload>
        </div>
        <div class="update_batch_btn">
          <Button :loading="batch_update_confirm_loading" @click="batch_update_confirm"
            :disabled="!batch_update_file_url" icon="ios-cloud-upload-outline" type="primary">确认更新</Button>
        </div>
      </div>
    </Modal>

    <Drawer title="编辑花名册" v-model="editor_show" width="480" :mask-closable="false">
      <editor ref="editor" :project_id="project_id" :resume_id="current_item.resume_id" :roster_item="current_item"
        :columns="columns" :show="true" @change="editor_change"></editor>
    </Drawer>

    <Modal v-model="hmc_before_show" title="导出花名册选择" :mask-closable="false" :footer-hide="true" width="400">
      <div>
        <span style="margin-right: 10px">是否导出身份证照片:</span>
        <Switch v-model="hmc_export_idcard" />
      </div>
      <div class="export_hmc_btn">
        <Button type="primary" @click="export_hmc">确认导出</Button>
      </div>
    </Modal>

    <Modal width="430" v-model="baoan_show" title="选择要进行的操作" :footer-hide="true">
      <div class="contract_button_div">
        <Button class="" @click="new_gongshang_baoan" style="margin-right: 10px" type="primary">
          <Icon type="ios-add-circle-outline" />
          工伤报案提交
        </Button>
        <Button class="" @click="gongshang_baoan_record">
          项目工伤报案列表(查看、完善数据)</Button>
        <Button class="" @click="gongshang_baoan_jiaocheng" style="margin-top: 10px">
          <Icon type="ios-book" />工伤报案流程学习
        </Button>
      </div>
    </Modal>


    <Modal width="500" v-model="dormitory_show" title="为员工分配宿舍" :footer-hide="true">
      <div class="dormitory_div">
        <div v-for="(item, i) in dormitory_list" :key="i" class="sushe_card"
          @click="add_dormitory_people_request(item)">
          <Tag color="primary">{{ item.people_number }}人间</Tag>
          <Tag color="success">{{ item.current_people_number }}/{{ item.people_number }}</Tag>
          <span class="iconfont iconditu"></span>
          {{ item.address }}
        </div>
      </div>
      <div @click="add_new_room" class="add_new_room">
        <Icon type="ios-add-circle-outline" />添加/管理员工宿舍
      </div>
    </Modal>


    <Modal width="500" v-model="geshui_upload_show" title="员工个税实名照片上传" :footer-hide="true">
      <div class="geshui_modal">
        <Upload multiple type="drag" :action="geshui_upload_url" :on-success="geshui_success" :show-upload-list=false>
          <div style="padding: 20px 0">
            <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
            <p>上传员工【{{ geshui_upload_item.name }}】本人个税APP【我的】页面截图</p>
          </div>
        </Upload>

        <div style="font-size: 13px;color:#ccc;padding:10px;cursor: pointer;;"
          @click="view_yuyan(geshui_upload_image_url)">
          {{ geshui_upload_image }}
          <Icon v-if="geshui_upload_image" type="ios-eye-outline" style="color:blue;font-size: 16px;" />
        </div>
        <div>
          <Checkbox v-model="geshui_check_idcard">校验银行卡张数</Checkbox>
          <Checkbox v-model="geshui_check_name">校验员工姓名</Checkbox>
        </div>
        <div class="geshui_btn">
          <Button :loading="geshui_loading" type="primary" @click="geshui_submit"
            :disabled="!geshui_upload_image">确认更新</Button>
        </div>
      </div>

    </Modal>

    <Modal width="700" v-model="search_idcard_list_show" title="填写身份证号列表">
      <div>
        格式要求：复制表格列，粘贴进来即可。需要带表头（如身份证号），一行一个身份证号。
      </div>
      <div class="search_idcard_list">
        <TablePaste @on-success="search_idcard_list_success" @on-error="search_idcard_list_error" />
      </div>
    </Modal>
    <staff_bankcard ref="staff_bankcard"></staff_bankcard>


    <resume_detail ref="resume_detail"></resume_detail>

    <update_idcard @change="update_idcard_change" ref="update_idcard"></update_idcard>

    <import_hmc ref="import_hmc"></import_hmc>
    <import_excel_v1 ref="import_excel_v1"></import_excel_v1>
  </div>
</template>

<script>
import watermark from "@/utils/shuiyin.js";
import my_menu2 from "@/component/menu/menu2.vue";
import staff_bankcard from "./component/staff_bankcard.vue";

import editor from "./component/editor.vue";
import update_idcard from "./component/update_idcard2.vue";
import { http, open_new_page, get_view_file_url } from "@/utils/http.js";
import resume_detail from "./component/resume_detail.vue";
import import_hmc from "./component/import_hmc.vue";
import import_excel_v1 from '@/component/import_excel/import_v1.vue'

export default {
  components: {
    editor,
    resume_detail,
    update_idcard,
    import_hmc,
    my_menu2,
    import_excel_v1,
    staff_bankcard
  },
  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      table_loading: false,
      menu_show: true,
      project_id: "",
      job_status: 0,
      columns: [],
      table_data: [],
      roster_template_show: false,
      roster_template_list: [],
      roster_select: "",
      company_short_name: "",
      roster_template_info: { name: "" },
      current_item: {},
      editor_show: false,
      page: 1,
      limit: 20,
      total_count: 0,
      contract_dict: {},
      total_contract_dict: {},
      contract_modal_show: false,
      insurance_count_dict: {},
      insurance_show: false,
      table_loading: false,
      search_type: "name",
      search_value: "",
      project_type: 0,
      selection_data: [],
      project_options: [],
      transfer_project_show: false,
      to_project_id: "",
      transfer_time_type: 'old',
      transfer_type: '01',
      transfer_contract_status: 0,
      transfer_insurance_status: 0,

      batch_update_show: false,
      batch_update_file_update:
        process.env.VUE_APP_HOST +
        "/roster_manage/roster_update/file_upload?token=" +
        this.$cookies.get("dx_token"),
      batch_update_file_url: "",
      batch_update_confirm_loading: false,

      hmc_before_show: false,
      // 导出身份证照片
      hmc_export_idcard: false,

      baoan_show: false,
      dormitory_list: [],
      dormitory_show: false,
      faxin_show: false,
      geshui_upload_item: {},
      geshui_upload_show: false,
      geshui_upload_url:
        process.env.VUE_APP_HOST +
        "/roster_manage/detail/upload_geshui_img?token=" +
        this.$cookies.get("dx_token"),
      geshui_upload_image: '',
      geshui_upload_image_url: '',
      geshui_loading: false,
      geshui_check_idcard: true,
      geshui_check_name: true,

      transfer_project_duanqi_show: false,
      search_type_list: [
        { 'value': "name", 'label': '按姓名' },
        { 'value': "idcard_list", 'label': '按身份证号列表' },
      ],
      search_idcard_list: [],
      search_idcard_list_show: false
    };
  },
  mounted() {
    var that = this;
    //  生成水印
    this.create_shuiyin();
    //
    var query = this.$route.query;
    this.project_id = query.project_id;
    this.job_status = query.job_status;
    this.project_name = query.project_name;
    var search_type = query.search_type;
    var search_value = query.search_value
    if (!this.project_id) {
      alert("参数异常");
    }
    if (!this.job_status) {
      alert("参数异常");
    }
    console.log(search_type, search_value)
    if (search_type && search_value) {
      this.search_type = search_type
      this.search_value = search_value
    }

    this.get_roter_list();

    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight;
        window.fullWidth = document.documentElement.clientWidth;
        that.windowHeight = window.fullHeight; // 高
        that.windowWidth = window.fullWidth; // 宽
        console.log("宽高变化", that.windowHeight, that.windowWidth);
      })();
    };

    this.get_porject_options();
    this.get_dormitory()
  },

  methods: {


    search_idcard_list_success(e) {
      console.log('成功', e)
      let _list = []
      for (let i = 0; i < e.data.length; i++) {
        console.log('--**--', e.data[i])
        console.log(e.data[i]['key0'])

        _list.push(e.data[i]['key0'])
      }
      this.search_idcard_list = _list;
      if (_list.length > 0) {
        this.$Message.success(`解析数据成功，共${e.data.length}条`)
      }
      console.log(this.search_idcard_list)



    },
    search_idcard_list_error() {
      console.log('失败', e)
      this.$Message.error('解析数据失败，请检查数据格式')

    },

    geshui_submit() {
      if (this.geshui_upload_image == '') {
        this.$Message.error('请先上传图片')
        return;
      }
      var that = this;
      this.geshui_loading = true
      var obj = {
        resume_id: this.geshui_upload_item.resume_id,
        image_object: this.geshui_upload_image,
        geshui_check_idcard: this.geshui_check_idcard,
        geshui_check_name: this.geshui_check_name,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/detail/geshui_img_submit",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.geshui_upload_show = false
            that.get_roter_list()
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.geshui_loading = false
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    geshui_success(e) {
      console.log(e)
      if (e.code == 0) {
        this.$Message.success('图片上传完成')
        this.geshui_upload_image = e.data.img_object_name
        this.geshui_upload_image_url = e.data.url
      } else {
        this.$Message.error(e.msg)
      }

    },

    view_yuyan(url) {
      this.$ImagePreview.show({
        previewList: [url]
      });
    },

    upload_geshui(row) {
      this.geshui_upload_show = true
      this.geshui_upload_item = row
    },

    get_dormitory() {
      console.log('获取宿舍列表2')
      var that = this;
      var obj = {
        project_id: this.project_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/project_detail/dormitory/project_dormitory",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.dormitory_list = res.data.dormitory_list
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },


    click_add_bed() {

      var that = this;


      if (this.selection_data.length == 0) {
        this.$Message.error("至少选择一位");
        return;
      }
      if (this.selection_data.length > 1) {
        this.$Message.error("最多选择一位");
        return;
      }

      this.dormitory_show = true


    },

    view_geshui(row) {
      this.$ImagePreview.show({
        previewList: [row.geshui_img]
      });
    },

    add_dormitory_people_request(item) {
      var current_item = this.selection_data[0];
      var resume_id = current_item.resume_id
      var that = this;
      var obj = {
        resume_id: resume_id,
        dormitory_id: item.dormitory_id

      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/project_detail/dormitory/dormitory_people_add",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_dormitory()
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });

    },

    gongshang_baoan() {
      this.baoan_show = true;
    },

    gongshang_baoan_jiaocheng() {
      var url = "https://alidocs.dingtalk.com/i/p/7xZBGL2jAMMXL1wvrqGd9Mr2dYr33zaV";
      open_new_page(url);
    },

    gongshang_baoan_record() {
      var project_id = this.project_id;

      var url =
        "https://insurance.daxiangsys.com/compenset/beian/record?project_id=" +
        project_id;
      // var url =
      // "http://127.0.0.1:8007/compenset/beian/record?project_id=" +
      // project_id;
      open_new_page(url);
    },

    //新报案
    new_gongshang_baoan() {
      var that = this;
      var interview_id_list = [];
      for (let i = 0; i < this.selection_data.length; i++) {
        interview_id_list.push(this.selection_data[i]["interview_id"]);
      }

      if (this.selection_data.length == 0) {
        this.$Message.error("至少选择一位");
        return;
      }
      if (this.selection_data.length > 1) {
        this.$Message.error("最多选择一位");
        return;
      }

      var resume_id = this.selection_data[0].resume_id;
      var project_id = that.project_id;
      var url =
        "https://insurance.daxiangsys.com/compenset/beian/create?resume_id=" +
        resume_id +
        "&project_id=" +
        project_id;

      open_new_page(url);
    },

    batch_update_confirm() {
      var that = this;
      var obj = {
        url: this.batch_update_file_url,
      };
      this.batch_update_confirm_loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/roster_update/batch_update",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 6,
            });
            that.batch_update_show = false;
            that.get_roter_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.batch_update_confirm_loading = false;
        })
        .catch((res) => {
          that.batch_update_confirm_loading = false;
          console.log(res, "请求出错");
        });
    },

    //批量更新文件上传成功
    update_file_upload_success(e) {
      console.log(e);
      // 保存文件
      this.batch_update_file_url = e.data.object_name;
    },

    batch_update_template() {
      var that = this;
      var obj = {
        project_id: this.project_id,
        job_status: Number(this.job_status),
        page: this.page,
        search_value: this.search_value,
        search_type: this.search_type,
        download_update_template: 1,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/detail/roster_list",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            this.$Modal.confirm({
              title: "提示",
              content: "<p>模板整理完成，是否下载</p></p>",
              onOk: () => {
                var name = that.company_short_name + "批量更新模板.xls";
                that.download_file(res.data.template_url, name);
                // open_new_page(res.data.template_url);
              },
              onCancel: () => { },
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    download_file(url, name) {
      // var url = this.down_url;
      // var name = this.filename;

      fetch(url)
        .then((_) => _.blob())
        .then((_) => {
          const link = document.createElement("a");
          link.href = URL.createObjectURL(_);
          link.setAttribute("download", name); // 自定义文件名
          link.click();
        });
    },

    add_new_room() {
      var url = '/workbench/my_project?project_id=' + this.project_id
      open_new_page(url)
    },

    bank_home() {
      open_new_page("/");
    },

    get_porject_options() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/detail/project_options",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.project_options = res.data.project_options;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_transfer_project_affirm() {
      var that = this;
      var interview_id_list = [];
      for (let i = 0; i < this.selection_data.length; i++) {
        interview_id_list.push(this.selection_data[i]["interview_id"]);
      }

      if (this.selection_data.length == 0) {
        this.$Message.error("至少选择一位");
        return;
      }

      if (this.to_project_id == "") {
        this.$Message.error("请选择目标项目");
        return;
      }

      var obj = {
        current_project_id: this.project_id,
        to_project_id: this.to_project_id,
        interview_id_list: interview_id_list,
        time_type: this.transfer_time_type,
        transfer_type: this.transfer_type,
        contract_status: this.transfer_contract_status,
        insurance_status: this.transfer_insurance_status
      };
      that.request_transfer_project(obj);
    },


    click_transfer_project_duanqi_affirm() {
      var that = this;
      var interview_id_list = [];
      for (let i = 0; i < this.selection_data.length; i++) {
        interview_id_list.push(this.selection_data[i]["interview_id"]);
      }

      if (this.selection_data.length == 0) {
        this.$Message.error("至少选择一位");
        return;
      }


      var obj = {
        interview_id_list: interview_id_list,
      };
      that.request_transfer_project_duanqi(obj);
    },


    click_transfer_project_duanqi() {
      var that = this;
      var interview_id_list = [];
      for (let i = 0; i < this.selection_data.length; i++) {
        interview_id_list.push(this.selection_data[i]["interview_id"]);
      }

      if (this.selection_data.length == 0) {
        this.$Message.error("至少选择一位");
        return;
      }


      this.transfer_project_duanqi_show = true;
    },


    request_transfer_project_duanqi(obj) {
      var that = this;

      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/detail/transfer_project_duanqi",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.transfer_project_duanqi_show = false;
            that.get_roter_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },


    click_transfer_project() {
      var that = this;
      var interview_id_list = [];
      for (let i = 0; i < this.selection_data.length; i++) {
        interview_id_list.push(this.selection_data[i]["interview_id"]);
      }

      if (this.selection_data.length == 0) {
        this.$Message.error("至少选择一位");
        return;
      }

      this.transfer_project_show = true;
    },



    request_transfer_project(obj) {
      var that = this;

      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/detail/transfer_project",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.transfer_project_show = false;
            that.get_roter_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_import_hmc() {
      this.$refs.import_hmc.open(this.project_id);
    },

    //合同列表
    click_project_contract_list() {
      console.log("合同列表");
      // this.$router.push({
      //     path:'/roster_manage/contract',
      //     query:{
      //         project_id:this.project_id,
      //     }
      // })
      open_new_page(
        "/roster_manage/contract?project_id=" +
        this.project_id +
        "&entry_status=" +
        this.job_status,
        "_blank"
      );
    },

    export_hmc_before() {
      this.hmc_before_show = true;
    },

    //导出花名册
    export_hmc() {
      var that = this;

      if (this.hmc_export_idcard) {
        var is_export_idcard = 1;
        this.$Message.info("导出身份证照片");
      } else {
        var is_export_idcard = 0;
        this.$Message.info("不导出身份证照片");
      }
      this.hmc_before_show = false;

      var _dict = {
        project_id: that.project_id,
        is_export_idcard: is_export_idcard,
      };

      if (this.job_status == 0) {
        var url = "/roster_manage/detail/export_zaizhi";
      } else {
        var url = "/roster_manage/detail/export_lizhi";
      }

      var msg1 = this.$Message.loading({
        content: "正在导出，请稍等，不要多次点击",
        duration: 20,
      });
      http("post", process.env.VUE_APP_HOST + url, _dict, true)
        .then((res) => {
          if (res.code == 0) {
            var url = res.data.url;
            var img_zip_url = res.data.img_zip_url;
            var object_name = res.data.object_name;

            get_view_file_url(object_name);

            that.$Modal.confirm({
              title: "提示",
              content: "<p>导出完成，为防止下载被拦截，请点击确认后开始下载文件</p>",
              onOk: () => {
                get_view_file_url(object_name);
                // open_new_page(url);
                // if (img_zip_url) {
                //   open_new_page(img_zip_url);
                // }
              },
              onCancel: () => { },
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    selection_change(e) {
      this.selection_data = e;
    },

    //批量参保
    batch_insured() {
      var that = this;
      var resume_id_list = [];
      for (let i = 0; i < this.selection_data.length; i++) {
        resume_id_list.push(this.selection_data[i]["resume_id"]);
      }

      if (this.selection_data.length == 0) {
        this.$Message.error("至少选择一位");
        return;
      }

      var _dict = {
        resume_id_list: resume_id_list,
        project_id: that.project_id,
      };

      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/detail/batch_insurance",
        _dict,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            var url = res.data.url;
            open_new_page(url);
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    search() {
      this.page = 1;
      this.get_roter_list();
    },

    // click_insurance_audit() {
    //     var current_item = this.current_item
    //     console.log(current_item)
    //     var _dict = {
    //         name: current_item.name,
    //         idcard: current_item.idcard,
    //     }
    //     var resume_list = [_dict]

    //     var path = "project_id=" + this.project_id + '&resume_data=' + JSON.stringify(resume_list)
    //     var url = 'https://insurance.daxiangsys.com/create?' + path
    //     open_new_page(url)

    // },

    //点击身份证号
    click_idcard_num(item) {
      this.$refs.update_idcard.open(item);
    },

    update_idcard_change() {
      this.get_roter_list();
    },

    //点击名称
    click_name(item) {
      this.$refs.resume_detail.open(item, this.project_id);
    },

    click_contract(item) {
      this.current_item = item;
      this.contract_modal_show = true;
    },

    contract_ok() { },

    //点击更新实名
    click_update_certification(item) {
      var resume_id = item.resume_id;
      var that = this;
      this.$Modal.confirm({
        title: "实名检测",
        content: "<p>确认要对姓名跟身份证进行实名校验吗?" + "</p>",
        onOk: () => {
          that.update_certification_request(resume_id);
        },
        onCancel: () => { },
      });
    },

    update_certification_request(resume_id) {
      var that = this;
      var obj = {
        resume_id: resume_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/detail/certification",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_roter_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_sing_contract(status) {
      var item = this.current_item;
      console.log(item, status);
      var that = this;

      var obj = {
        project_id: that.project_id,
        resume_id: item.resume_id,
        status: status,
        interview_status: "长期工",
        interview_id: item.interview_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/detail/sign_contract",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            var url = res.data.sign_url;
            open_new_page(url);
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_contract_list() {
      var that = this;
      console.log(this.current_item);

      var obj = {
        project_id: that.project_id,
        idcard: this.current_item.idcard,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/detail/contract_list",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            // that.$Message.success({
            //     content: res.msg,
            //     duration: 3,
            // });
            var url = res.data.sign_url;
            open_new_page(url);
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    create_shuiyin() {
      var user_info = this.$cookies.get("dx_user_info");
      if (user_info) {
        var name = user_info.name;
        var time = new Date().toLocaleString();
        console.log(time);
        watermark.set("保密-" + name + "-" + time, "0px");
      }
    },

    editor_change(e) {
      if (e == 'phone_change') {
        this.editor_show = false
      }
      this.get_roter_list();
    },

    click_editor(item) {
      this.current_item = JSON.parse(JSON.stringify(item));
      this.editor_show = true;
    },

    click_insurance(item) {
      this.current_item = JSON.parse(JSON.stringify(item));
      this.insurance_show = true;
    },

    update_roster() {
      var that = this;

      if (this.roster_select == "") {
        this.$Message.error("请选择模板");
        return;
      }
      var obj = {
        project_id: that.project_id,
        roster_id: that.roster_select,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/detail/roster_template_update",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_roter_list();
            that.roster_template_show = false;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    get_roster_template() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/detail/roster_template",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.roster_template_list = res.data.roster_template;
            that.roster_select = res.data.roster_template[0]["value"];
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    page_change(e) {
      this.page = e;
      this.get_roter_list();
    },

    get_roter_list() {
      var that = this;
      let search_value = ''
      if (this.search_type == 'name') {
        search_value = this.search_value
      }
      if (this.search_type == 'idcard_list') {
        search_value = this.search_idcard_list
      }
      var obj = {
        project_id: this.project_id,
        job_status: Number(this.job_status),
        page: this.page,
        search_value: search_value,
        search_type: this.search_type,
      };
      this.table_loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/detail/roster_list",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.menu_show = false;
            setTimeout(function () {
              that.menu_show = true;
            }, 1);

            console.log(res.data.company_short_name);
            that.company_short_name = res.data.company_short_name;
            that.columns = res.data.columns;
            that.table_data = res.data.table_data;
            that.roster_template_info = res.data.template_info;
            that.limit = res.data.limit;
            that.total_count = res.data.total_count;
            that.project_type = res.data.project_type;
            // 获取合同数据
            that.get_contract_data();
            // 获取保险数据
            that.get_insurance_data();
          } else if (res.code == 201) {
            that.get_roster_template();
            that.roster_template_show = true;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.table_loading = false;
        })
        .catch((res) => {
          that.table_loading = false;

          console.log(res, "请求出错");
        });
    },

    //获取合同数据
    get_contract_data() {
      var that = this;
      var table_data = JSON.parse(JSON.stringify(this.table_data));
      var idcard_list = [];
      for (let i = 0; i < table_data.length; i++) {
        idcard_list.push(table_data[i]["idcard"]);
      }
      var obj = {
        idcard_list: idcard_list,
        project_id: this.project_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/detail/roster_contract",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.contract_dict = res.data.contract_dict;
            that.total_contract_dict = res.data.total_contract_dict;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //获取保险数据
    get_insurance_data() {
      var that = this;
      var table_data = JSON.parse(JSON.stringify(this.table_data));
      var idcard_list = [];
      for (let i = 0; i < table_data.length; i++) {
        idcard_list.push(table_data[i]["idcard"]);
      }
      var obj = {
        idcard_list: idcard_list,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/detail/roster_insurance",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.insurance_count_dict = res.data.count_dict;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //点击查看保险详情
    click_insurance_list() {
      var that = this;
      console.log(this.current_item);

      var obj = {
        project_id: that.project_id,
        resume_id: this.current_item.resume_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/detail/join_insurance",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            // that.$Message.success({
            //     content: res.msg,
            //     duration: 3,
            // });
            var url = res.data.url;
            open_new_page(url);
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //点击员工银行卡
    click_resume_bank_card(row) {
      this.$refs.staff_bankcard.open(row.resume_id);
    },

    cut_roster_status() {
      var query = this.$route.query;
      console.log(query);
      var project_id = query.project_id;
      var project_name = query.project_name;
      var job_status = query.job_status;

      if (job_status == 0) {
        this.job_status = 1;
        var status_msg = "离职";
      } else {
        this.job_status = 0;
        var status_msg = "在职";
      }

      this.$router.push({
        path: "/roster_manage/detail",
        query: {
          project_id: project_id,
          project_name: project_name,
          job_status: this.job_status,
        },
      });
      this.$Message.success("已经切换为-" + status_msg + "花名册");

      this.page = 1;
      this.get_roter_list();
    },
  },
};
</script>

<style scoped>
.search_idcard_list_div {
  display: flex;
  align-items: center;
}

.search_idcard_list_btn {
  background-color: #2776ff;
  border-radius: 2px;
  font-size: 13px;
  padding: 1px 5px;
  color: #fff;
  margin-left: 10px;
  cursor: pointer;
}

.search_idcard_list {
  height: 50vh;
  overflow: auto;
}

.bank_card_hover:hover {
  opacity: .6;
}

.bank_card1 {
  color: #fff;
  background-color: #0466dd;
  padding: 3px 5px;
  border-radius: 5px;
  cursor: pointer;
}

.bank_card2 {
  color: #fff;
  background-color: #f0022e;
  padding: 3px 5px;
  border-radius: 5px;
  cursor: pointer;
}

.add_new_room {
  cursor: pointer;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #0466dd
}

.geshui_btn {
  display: flex;
  justify-content: end;
  margin-top: 20px;
}

.geshui_modal {
  height: 250px;
  overflow: auto;
}

.dormitory_div {
  height: 300px;
  overflow: auto;
}

.iconditu {
  color: red
}

.sushe_card {
  margin: 5px;
  padding: 10px;
  box-shadow: 0 0 3px #e3e3e3;
  margin-bottom: 10px;
  cursor: pointer;
}

.sushe_card:hover {
  border: 1px solid #0466dd;
}

.export_hmc_btn {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.cut_roster {
  color: #e3e3e3;
  font-size: 13px;
  cursor: pointer;
  margin-left: 10px;
}

.cut_roster:hover {
  color: #fff;
}

.search_div_left {
  display: flex;
  align-items: center;
}

.search_div_span {
  font-size: 12px;
  margin-left: 10px;
  color: #ccc;
}

.idcard_span_div {
  display: flex;
  align-items: center;
}

.sfz_icon1 {
  cursor: pointer;
  font-size: 14px;
  color: #01b729;
  margin-left: 2px;
}

.sfz_icon2 {
  cursor: pointer;
  font-size: 14px;
  color: #fb0000;
  margin-left: 2px;
}

.update_batch_btn {
  display: flex;
  justify-content: flex-end;
}

.update_batch_div {
  margin: 10px;
  padding: 10px;
  border-bottom: 1px solid #ececec;
}

.back_home {
  color: #96badd;
  cursor: pointer;
}

.back_home:hover {
  color: #fff;
}

.transfer_button {
  text-align: right;
}

.transfer_toproject_box {
  margin: 10px 0;
}

.transfer_title {
  font-weight: 600;

}

.transfer_tishi {
  font-size: 13px;
  background-color: #ffd3d3;
  padding: 10px;
}

.transfer_tishi2 {
  font-size: 13px;
  background-color: #d2ef9b;
  padding: 10px;
}

.action2 {
  display: flex;
  align-items: center;
}

.contract_point {
  position: absolute;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: red;
  right: -1px;
  top: 0px;
}

.button_span {
  margin: 0 5px;
  color: #a6a7a9;
}

.export_hmc2 {
  font-size: 12px;
  color: rgb(227, 227, 227);
  cursor: pointer;
}

.export_hmc2:hover {
  color: #fff;
}

.export_hmc {
  font-size: 12px;
  color: rgb(227, 227, 227);
  cursor: pointer;
}

.export_hmc:hover {
  color: #fff;
}

.search_div {
  margin: 10px 0 5px 10px;
  padding: 0 15px 0 0;
  display: flex;
  justify-content: space-between;
}

.main {
  min-width: 1000px;
}

.update_idcard_box {
  height: 300px;
  overflow: auto;
}

.idcard_num:hover {
  cursor: pointer;
  color: #0466dd;
}

.roster_name {
  color: #0466dd;
  cursor: pointer;
}

.contract_button_div {
  display: flex;
  flex-wrap: wrap;
}

.roster_name:hover {
  color: #00aeff;
}

.contract_button_class {
  text-align: left;
  width: 120px;
  font-size: 13px;
  margin-right: 10px;
}

.contract_button_class2 {
  margin-top: 10px;
  text-align: left;
  width: 120px;
  font-size: 13px;
  margin-right: 10px;
}

.contract_button_class3 {
  margin-top: 10px;
  text-align: left;
  width: 120px;
  font-size: 13px;
  margin-right: 10px;
}

.iconweirenzheng {
  font-size: 12px;
  color: #fb0000;
  margin-left: 3px;
  cursor: pointer;
}

.iconrenzheng {
  font-size: 10px;
  color: #01b729;
  margin-left: 3px;
  cursor: pointer;
}

.page_div {
  display: flex;
  justify-content: center;
}

.editor_table {
  color: #0466dd;
  cursor: pointer;
}

.editor_table2 {
  color: #0466dd;
  cursor: pointer;
  position: relative;
}

.editor_div {
  font-size: 12px;
  align-items: center;
}

.options_box {
  padding: 10px 10px 0 10px;
  display: flex;
  justify-content: flex-end;
}

.roster_template_name {
  color: #6d9fd4;
  font-size: 10px;
  cursor: pointer;
  font-size: 10px;
}

.roster_template_button {
  display: flex;
  justify-content: flex-end;
  padding-top: 30px;
  padding-right: 20px;
}

.roster_item {
  text-align: center;
}

.roster_detail {
  font-weight: 600;
  font-size: 13px;
  color: #333;
  text-align: center;
  margin-bottom: 20px;
}

.table_box {
  padding: 10px 10px 5px 10px;
  overflow: auto;
}

.page_title {
  font-weight: 300;
  display: flex;
  align-items: center;
  justify-content: space-between;
  letter-spacing: 3px;
  padding: 0 15px 0 15px;
  background-color: #0466dd;
  color: #fff;
  height: 40px;
  line-height: 40px;
}
</style>
